module.exports = __webpack_public_path__ + "img/sell-car300x169.0f166d39.png";